import { propsFactory } from '@ngneat/elf';

// See https://ngneat.github.io/elf/docs/miscellaneous/props-factory
export const { withInFlight, updateInFlight, selectInFlight } = propsFactory('inFlight', {
  initialValue: false
});
